// 상수 모음
export const COLS = 12;
export const ROW_H = 30;

// 🔼 에디터를 크게 쓰기 위해 최대 높이 여유 증가
export const MAX_H = 60;

export const MIN_W = 4;
export const MAX_W = 12;

// 기본 블록 최소 높이(행). 표/텍스트엔 6이면 충분하지만 에디터는 따로 키웁니다.
export const DEFAULT_H = 6;
export const DEFAULT_W = 12;

export const MAX_HISTORY = 50;

export const DEFAULT_TABLE_COLUMNS = [
  { key: "code", label: "코드", type: "text", width: "12%" },
  { key: "name", label: "품명", type: "text", width: "20%" },
  { key: "spec", label: "규격", type: "text", width: "18%" },
  { key: "unit", label: "단위", type: "text", width: "8%" },
  { key: "qty", label: "수량", type: "number", width: "10%" },
  { key: "price", label: "단가", type: "number", width: "12%" },
  {
    key: "amount",
    label: "금액",
    type: "calc",
    width: "12%",
    calc: (r) => Number(r.qty || 0) * Number(r.price || 0),
  },
  { key: "remark", label: "비고", type: "text", width: "8%" },
];

// 🔑 레이아웃: 에디터를 '종이 한 장' 느낌으로 크게 시작
// - block-editor h: 28행 (ROW_H 30px 기준 약 840px)
// - 뒤 블록들의 y를 31로 밀어줌(3 + 28)
export const DEFAULT_LAYOUT = [
  { i: "block-title", x: 0, y: 0, w: 8, h: 3, minH: 3 },
  { i: "block-date", x: 8, y: 0, w: 4, h: 3, minH: 3 },

  // ⬇️ 여기만 크게
  { i: "block-editor", x: 0, y: 3, w: 12, h: 28, minH: 12 },

  // ⬇️ 에디터가 커진 만큼 아래 블록 시작 y를 31(=3+28)로 옮김
  { i: "block-note", x: 0, y: 31, w: 4, h: 8, minH: 4 },
  { i: "block-photos", x: 4, y: 31, w: 4, h: 8, minH: 4 },
  { i: "block-files", x: 8, y: 31, w: 4, h: 8, minH: 4 },
];
